import React, { useEffect, useMemo, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import {
  Calendar,
  CheckCircle2,
  FolderTree,
  Grid,
  LayoutGrid,
  ListIcon,
  ShieldX,
  Tag,
  User,
  Users2,
} from "lucide-react";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import { motion } from "framer-motion";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import XCloseIcon from "../../../../component/icons/x-close";
import { Link } from "react-router";
import LeadQuickView from "./popup";
import Chip from "../../../../component/ui/chip";
import LeadBoard from "./kanban/LeadBoard";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import Tooltip from "../../../../component/ui/tooltip";
import FileCode1Icon from "../../../../component/icons/file-code-1";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableDepartmentTag,
  TableFilterReturn,
  TableFirstCol,
  TableHead,
  TableHeaderWrap,
  TableLink,
  TableRow,
} from "../../../../component/table/table-layout";
import StatusChip from "../../../../component/ui/chip/status";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../component/icons/action-card-icon";
import { CustomDropdownMenuDivider } from "../../../../component/ui/dropdown/CustomDropdownMenuDivider";
import ChevronDownIcon from "../../../../component/icons/chevron-down";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";
import ConvertLeadToDeal from "../../../../component/modals/convert-lead/convert-lead-to-deal";
import BulkEdit from "../../../../component/modals/bulk-edit/bulk-edit";
import ContactQuickView from "../../../mainAccounts/accounts/contact/popup";
import Avatar from "../../../../component/ui/avatar";
import AvatarProfile from "../../../../component/ui/profile";
import UpdateLeadStatus from "../../../../component/modals/update-lead-status";
import UpperTabs from "../../../../component/upper-tab";
import leadUpperTabIcons from "../../../../component/icons/lead-upper-tab-icons";
import PlusIcon from "../../../../component/icons/plus";
import { TitleHeading } from "../../../../component/ui/layout";

const Lead = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [brands, setBrands] = useState([]);
  const [products, setProducts] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [viewType, setViewType] = useState("list");
  const [empData, setEmpData] = useState({});
  const [boardFilters, setBoardFilters] = useState([]);
  const [showBoardFilterModal, setShowBoardFilterModal] = useState(false);
  const [groupBy, setGroupBy] = useState(); // default
  const [boardSaveFilters, setBoardSaveFilters] = useState([]);
  const [showLead, setShowLead] = useState(false);
  const [currentData, setCurrentData] = useState({});
  const [PackageList, setPackageList] = useState([]);
  const [DealStages, setDealStages] = useState([]);

  const [usersList, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [country, setCountry] = useState([]);

  const [Clients, setClients] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreClients, setHasMoreClients] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(false);

  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);
  const [total, setTotal] = useState(0);

  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);

  const [selectedDeals, setSelectedDeals] = useState({
    lead_ids: [],
    user_ids: [],
  });

  const [exportTo, setExportTo] = useState(false);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(100);

  // for bulkedit
  const [bulkDataChange, setBulkDataChange] = useState(false);
  const [showBulkConvertModal, setShowBulkConvertModal] = useState(false);
  const [bulkDatavalue, setBulkDatavalue] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [showStatus, setShowStatus] = useState(false);
  const [currentStatus, setCurrentStatus] = useState({});
  const [ProductsFilters, setProductsFilters] = useState({});

  const bulkSelectChange = (e) => {
    console.log("sel", selectedDeals);
    setBulkDatavalue(e);
    if (!e) {
      return;
    }

    if (e == "changeData") {
      setBulkDataChange(true);
    }
    if (e == "convertToDeal") {
      setShowBulkConvertModal(true);
    }
  };

  const toggleSelectAll = (checked) => {
    if (checked) {
      const lead_ids = apiData.filter((d) => d.leadid).map((d) => d.leadid);

      const user_ids = apiData
        .filter((d) => !d.leadid && d.userid)
        .map((d) => d.userid);

      setSelectedDeals({ lead_ids, user_ids });
    } else {
      setSelectedDeals({ lead_ids: [], user_ids: [] });
    }
  };

  const toggleSelectRow = (id, type) => {
    setSelectedDeals((prev) => {
      const key = type === "lead" ? "lead_ids" : "user_ids";
      const exists = prev[key].includes(id);

      return {
        ...prev,
        [key]: exists ? prev[key].filter((x) => x !== id) : [...prev[key], id],
      };
    });
  };

  const handleExport = async (type, localData = null) => {
    try {
      if (localData && localData.length > 0) {
        exportData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";

      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Leads...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // Convert filters array → object
      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);

      const res = await apiCall({
        url: `leads/get-leads`, // your actual endpoint
        method: "post",
        data: apiData,
      });

      const leadsData = res?.data || res?.leads || [];
      if (!leadsData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportData(leadsData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  const exportData = (data, type) => {
    const visibleColumns = tableHeader
      ?.filter((col) => col.is_visible === 1 && col.show == 1)
      ?.map((col) => ({ key: col.key, label: col.value }));

    const filteredData = data.map((row) => {
      const obj = {};

      obj["Lead Name"] =
        row?.name && row.name !== "0" && row.name.trim() !== ""
          ? row.name
          : row?.leadname || row?.fullname || "-";

      visibleColumns.forEach(({ key, label }) => {
        if (key === "name") return; // skip, already handled

        if (key === "assigned") {
          obj[label || "Assigned To"] = Array.isArray(row.assigned_users)
            ? row.assigned_users.map((u) => u.name).join(", ")
            : "-";
        } else if (key === "leadtype") {
          obj[label || "Lead Type"] = row[key] === "unpaid" ? "Unpaid" : "Paid";
        } else if (key === "status") {
          obj[label || "Lead Status"] = row[key] || "-";
        } else if (key === "last_comment") {
          obj[label || "Last Comment"] = row?.last_comment?.comment || "-";
        } else if (["created_at", "updated_at"].includes(key)) {
          obj[label || key] = row[key]
            ? dayjs(row[key]).format("DD-MMM-YYYY")
            : "-";
        } else {
          obj[label || key] = row[key] ?? "-";
        }
      });

      return obj;
    });

    const fileName = `leads_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}`;

    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(filteredData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Leads");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Lead data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const getBoardFilter = (val) => {
    setBoardSaveFilters(val);
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getBrands();
    getProducts();
    // DealPackage();
    DealStage();
    fetchUsers();
    Countries();
    getLeadStatus();
  }, []);

  const Countries = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `location/get-countries`,
      });
      setCountry(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const loadClients = async (pageNum = 1, search = "") => {
    if (isLoadingClients || !hasMoreClients) return;
    setIsLoadingClients(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `users/customers-list?page=${pageNum}&limit=10&search=${encodeURIComponent(
          search,
        )}`,
      });

      const newClients = res?.customers || [];
      if (pageNum === 1) {
        setClients(newClients); // replace results when searching
      } else if (newClients.length === 0) {
        setHasMoreClients(false);
      } else {
        setClients((prev) => [...prev, ...newClients]);
        setPage(pageNum);
      }
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setIsLoadingClients(false);
    }
  };

  useEffect(() => {
    loadClients(1); // load first page once
  }, []);

  const getSubProducts = async (productId) => {
    if (!productId) return;
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${productId}`,
      });
      setSubProducts(res?.data || []);
    } catch (error) {
      console.error("Error fetching sub products:", error);
    }
  };

  const getPackages = async (subProductId) => {
    if (!subProductId) return;
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const [tabs, setTabs] = useState([]);

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    let apiData = { page: page, page_quantity: 100 };
    let extraUrl = `&page=${page || 1}&page_quantity=${page_quantity}`;
    for (let i = 0; i < filter?.length; i++) {
      extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `leads/get-leads?view=myleads${extraUrl}`,
        data: apiData,
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }

      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);
      setTablePagination(res?.pagination);
      setTotal(res?.pagination?.total);
      setTabs(res?.shortcut_filters);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setShowLead(false);
    setCurrentData({});
    setEmpPopup(false);
    setEmpData({});

    setCurrentStatus({});
    setShowStatus(false);
  };

  const onStatusUpdate = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  const getBrands = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      setBrands(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const getProducts = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });

      setProducts(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Products:", error);
    }
  };

  // const DealPackage = async () => {
  //   try {
  //     const res = await apiCall({
  //       method: "get",
  //       url: `brands/brand-packages-list?is_paginate=0`,
  //     });

  //     setPackageList(res.data);
  //   } catch (error) {
  //     console.warn("Error : ", error);
  //   }
  // };

  const getLeadStatus = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "get-dropdown-list",
      });
      console.log("res?.data", res?.data);

      setStatusList(res?.data?.lead_status || []);
      setProductsFilters(res?.data?.products || []);
    } catch (error) {
      console.warn("Error fetching Package:", error);
    }
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost",
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const filterModalData = [
    {
      name: "name",
      label: "Name",
      options: ["contains"],
      selectedOpt: "contains",
      value: "",
      type: "text",
    },
    {
      name: "product",
      label: "Product",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: ProductsFilters,
      dropdownKey: "value",
      dropdownVal: "id",
      betweenType: "date",
    },

    {
      name: "records_type",
      label: "Records Type",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Lead With Deals", value: "leads_with_deals" },
        { label: "Just Leads", value: "just_leads" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },

    {
      name: "leadsource",
      label: "Brand",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: brands,
      dropdownKey: "brandname",
      dropdownVal: "brandsid",
    },

    {
      name: "phone",
      label: "Phone",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "number",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },

    // {
    //   name: "leadtime",
    //   label: "Date",
    //   options: ["is", "between"],
    //   selectedOpt: "is",
    //   value: "",
    //   type: "date",
    //   dropdownKey: "label",
    //   dropdownVal: "value",
    //   betweenType: "date",
    // },
    {
      name: "leadtime",
      label: "Date",
      options: ["between"],
      selectedOpt: "between",
      value: "",
      type: "date",
      betweenType: "date",
    },
  ];

  const editLead = (ele) => {
    setCurrentData(ele);
    setShowLead(true);
  };

  const editLeadStatus = (ele) => {
    setCurrentStatus(ele);
    setShowStatus(true);
  };

  const getBoardFilterData = () => {
    if (groupBy === "leadsource") return filterModalData;
    if (groupBy === "created_time") return filterModalData;
    return filterModalData; // default
  };

  const tableRef = useRef(null);

  const removeFilter = (fIndex) => {
    let allFilter = [...filterReturn];
    allFilter.splice(fIndex, 1);
    setFilterReturn(allFilter);
    getData({ filter: allFilter });
  };

  const [activeTab, setActiveTab] = useState(null);

  const changeFilter = (val, eachTab) => {
    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        getData({ filters: updatedFilter });
      } else {
        getData({
          filters: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    setActiveTab(val);
  };

  const filteredData = useMemo(() => {
    if (!activeTab) return apiData;

    return apiData.filter((eachData) => {
      const fieldValue = eachData?.[activeTab?.header_key];
      const filterValue = activeTab.value;

      if (Array.isArray(fieldValue)) {
        return fieldValue.includes(activeTab?.value);
      }

      if (typeof fieldValue === "string" && fieldValue.includes(",")) {
        return fieldValue
          .split(",")
          .map((item) => item.trim())
          .includes(filterValue);
      }

      return fieldValue === activeTab?.value;
    });
  }, [activeTab, apiData]);

  const [apiApiFilter, setapiApiFilter] = useState(false);

  const innerChange = (eachTab, i) => {
    console.log("innerChange", "tabs", tabs, "eachTab", eachTab);
    if (eachTab?.type == "api_call") {
      setapiApiFilter(true);
      let isMatched = false;
      const updatedFilter = filterModalData
        ?.map((eachFilter) => {
          if (eachFilter?.name == eachTab?.header_key) {
            isMatched = true;
            return {
              ...eachFilter,
              isChecked: true,
              value: eachTab?.filter_val,
            };
          } else {
            if (eachFilter?.isChecked) {
              return eachFilter;
            } else {
              return false;
            }
          }
        })
        ?.filter(Boolean);
      if (isMatched) {
        setFilterReturn(updatedFilter);
        getData({ filter: updatedFilter });
      } else {
        getData({
          filter: [
            ...updatedFilter,
            {
              name: eachTab?.header_key,
              isChecked: true,
              value: eachTab?.filter_val,
            },
          ],
        });
      }
    } else {
      setapiApiFilter(false);
    }
    let allTabs = [...tabs];
    allTabs.splice(2, 0, eachTab);
    allTabs.splice(i + 1, 1);
    setTabs(allTabs);
    setActiveTab({ value: eachTab?.value, header_key: eachTab?.header_key });
  };

  return (
    <>
      <div className={`${Style.mainBody} `}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              {/* {(viewType === "list" ? filterReturn : boardFilters)?.length ? (
                <div className={Style.filterContainer}>
                  <p className={Style.searchText}>Search By</p>
                  {(viewType === "list" ? filterReturn : boardFilters).map(
                    (eachFilter, i) => (
                      <div className={Style.eachFilter} key={i}>
                        <p
                          onClick={() => {
                            if (viewType === "list")
                              setShowModalFilterTable(true);
                            if (viewType === "kanban")
                              setShowBoardFilterModal(true);
                          }}
                        >
                          <span>{eachFilter?.name} : </span>
                          <b>{eachFilter?.selectedOperator}</b>
                          <em>
                            {Array.isArray(eachFilter?.value)
                              ? eachFilter.value.join(", ")
                              : eachFilter?.value}
                          </em>
                        </p>
                        <span
                          className={Style.searchClosedBtn}
                          onClick={() => {
                            if (viewType === "list") removeFilter(i);
                            if (viewType === "kanban") {
                              let all = [...boardFilters];
                              all.splice(i, 1);
                              setBoardFilters(all);
                            }
                          }}
                        >
                          <div className={Style.icon}>
                            <XCloseIcon />
                          </div>
                        </span>
                      </div>
                    )
                  )}
                </div>
              ) : null} */}

              <TableFilterReturn
                filterReturn={viewType === "list" ? filterReturn : boardFilters}
                onChange={(allFilter) => {
                  if (viewType == "list") {
                    setFilterReturn(allFilter);
                  } else {
                    setBoardFilters(allFilter);
                  }
                  getData({ filter: allFilter });
                }}
              />

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {viewType === "list" ? (
                    <div className="flex flex-col gap-1">
                      <TitleHeading title={"Leads"} className={"!pl-0"} />
                      <h3 className="text-gray-500 text-[14px] flex items-center gap-1">
                        {isLoading ? (
                          <>
                            <span className="h-[16px] w-[30px] bg-gray-300 rounded animate-pulse" />
                            <span className="h-[16px] w-[50px] bg-gray-300 rounded animate-pulse" />
                          </>
                        ) : (
                          `${total || 0} leads`
                        )}
                      </h3>
                    </div>
                  ) : (
                    // <div className={Style.bpfl_select}>
                    //   <select
                    //     onChange={(e) => {
                    //       getData({ page_quantity: e?.target.value });
                    //       setPageCount(1);
                    //       setPageItemsCount(e?.target.value);
                    //     }}
                    //   >
                    //     <option value="10">Leads View 10</option>
                    //     <option value="25">Leads View 25</option>
                    //     <option value="50">Leads View 50</option>
                    //     <option value="100">Leads View 100</option>
                    //     <option value={total}>Leads View all</option>
                    //   </select>
                    // </div>
                    // <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                    //   Lead Pipeline
                    // </div>
                    // <TitleHeading
                    //   title={`Lead Pipeline -
                    //     ${
                    //       groupBy
                    //         ? `${groupBy
                    //             ?.split("_")
                    //             .map(
                    //               (word) =>
                    //                 word.charAt(0).toUpperCase() +
                    //                 word.slice(1),
                    //             )
                    //             .join(" ")}`
                    //         : null
                    //     }

                    //   `}

                    //   className={"!pl-0"}
                    // />

                    <div className="flex flex-col gap-1">
                      <TitleHeading
                        title={"Lead Pipeline"}
                        className={"!pl-0"}
                      />
                      <h3 className="text-gray-500 text-[14px] flex items-center gap-1">
                        {isLoading ? (
                          <>
                            <span className="h-[16px] w-[30px] bg-gray-300 rounded animate-pulse" />
                            <span className="h-[16px] w-[50px] bg-gray-300 rounded animate-pulse" />
                          </>
                        ) : (
                          `By Smart Buckets`
                        )}
                      </h3>
                    </div>
                  )}

                  {(selectedDeals?.lead_ids?.length > 0 ||
                    selectedDeals?.user_ids?.length > 0) &&
                  viewType === "list" ? (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className={Style.bpfl_select}
                    >
                      <select
                        value={bulkDatavalue}
                        onChange={(e) => {
                          bulkSelectChange(e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          Action
                        </option>
                        <option value="changeData">Change data</option>
                        <option value="convertToDeal" disabled>
                          Convert to Deals
                        </option>
                        <option value="sendBulkEmail" disabled>
                          Send bulk email
                        </option>
                        {/* <option value="sendBulkLetter" disabled>Send Bulk letter</option> */}
                      </select>
                    </motion.div>
                  ) : null}
                </div>
                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    {/* Add lead Button */}

                    <div
                      className={Style.bpfl_action}
                      onClick={() => {
                        setShowLead(true);
                      }}
                    >
                      {/* <Tooltip
                        content={"Add Lead"}
                        position={"left center"}
                        className={`${Style.bpfl_actionBtn} ${Style.addBtn}`}
                      >
                        <div className={Style.icon}>
                          <PlusIcon size="1em" />
                        </div>
                      </Tooltip> */}
                    </div>

                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          (
                            viewType === "kanban"
                              ? boardFilters.length
                              : filterReturn.length
                          )
                            ? Style.active
                            : ""
                        }`}
                        onClick={() => {
                          if (viewType === "list")
                            setShowModalFilterTable(true); // list view ke liye
                          if (viewType === "kanban")
                            setShowBoardFilterModal(true); // board view ke liye
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    {/* List View Button */}
                    {/* <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"list view"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "list" ? Style.active : ""
                        }`}
                        onClick={() => {
                          setViewType("list");
                          setGroupBy();
                        }}
                      >
                        <div className={Style.icon}>
                          <ListIcon size={16} />
                        </div>
                      </div>
                    </Tooltip> */}
                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={`${viewType == "list" ? "Grid" : "list"} view`}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "list" || viewType === "kanban"
                            ? Style.active
                            : ""
                        }`}
                        onClick={() => {
                          if (viewType == "kanban") {
                            setViewType("list");
                            setGroupBy();
                          } else {
                            setGroupBy("special");
                            setViewType("kanban");
                          }
                        }}
                      >
                        <div className={Style.icon}>
                          {viewType == "list" ? (
                            // <Grid size={16} />
                            <LayoutGrid size={16} />
                          ) : (
                            <ListIcon size={16} />
                          )}
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "kanban" ? Style.disabled : ""
                        }`}
                        onClick={() => {
                          if (viewType !== "kanban")
                            setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>

                    {viewType === "list" ? (
                      <CustomDropdown
                        position="bottom-right"
                        className={`myDropdown`}
                      >
                        <CustomDropdownButton
                          arrow={false}
                          className="btnClass"
                        >
                          <DotsVerticalIcon />
                        </CustomDropdownButton>

                        <CustomDropdownMenu>
                          {/* {groupBy != "leadsource" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("leadsource");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Tag size={14} /> By Brand
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {groupBy != "special" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("special");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <FolderTree size={14} /> By Smart Buckets
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {groupBy != "created_time" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("created_time");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Calendar size={14} /> By Date
                            </div>
                          </CustomDropdownMenuList>
                        )} */}

                          {viewType === "list" ? (
                            <>
                              {/* <CustomDropdownMenuDivider /> */}

                              <CustomDropdownMenuList
                                className={Style.CustomDropdownMenuList}
                                closed={false}
                              >
                                <div
                                  className={Style.CustomDropdownMenuListBtn}
                                  onClick={() => setExportTo(!exportTo)}
                                >
                                  <div className="">
                                    <LayoutTopIcon /> Export to
                                  </div>
                                  <div
                                    className={`${Style.dropArrow} ${
                                      exportTo ? Style.isActive : null
                                    }`}
                                  >
                                    <ChevronDownIcon />
                                  </div>
                                </div>

                                {exportTo ? (
                                  <div className={Style.subItemMenu}>
                                    <CustomDropdownMenuList
                                      className={Style.subItemList}
                                      onClick={() => {
                                        const allSelectedIds = [
                                          ...selectedDeals.lead_ids,
                                          ...selectedDeals.user_ids,
                                        ];

                                        // { console.log(allSelectedIds) }

                                        const dataToExport =
                                          allSelectedIds.length > 0
                                            ? apiData.filter(
                                                (d) =>
                                                  allSelectedIds.includes(
                                                    d.leadid,
                                                  ) ||
                                                  allSelectedIds.includes(
                                                    d.userid,
                                                  ),
                                              )
                                            : apiData;

                                        // ✅ Call the new unified export function
                                        handleExport("csv", dataToExport);
                                      }}
                                    >
                                      <div className="d-flex align-items-center gap-1">
                                        <FileCode1Icon /> CSV
                                      </div>
                                    </CustomDropdownMenuList>

                                    <CustomDropdownMenuList
                                      className={Style.subItemList}
                                      onClick={() => {
                                        const dataToExport =
                                          selectedDeals.length > 0
                                            ? apiData.filter((d) =>
                                                selectedDeals.includes(
                                                  d.leadid || d.userid,
                                                ),
                                              )
                                            : apiData;

                                        // ✅ Call the new unified export function
                                        handleExport("excel", dataToExport);
                                      }}
                                    >
                                      <div className="d-flex align-items-center gap-1">
                                        <FileCode1Icon /> XLSX
                                      </div>
                                    </CustomDropdownMenuList>
                                  </div>
                                ) : null}
                              </CustomDropdownMenuList>

                              {/* <CustomDropdownMenuList>
                                <Link
                                  to="/leads/my-leads/lead-detail"
                                  className="d-flex align-items-center gap-1"
                                >
                                  <FileCode1Icon size={14} /> Lead Detail New
                                  Page
                                </Link>
                              </CustomDropdownMenuList> */}
                            </>
                          ) : null}
                        </CustomDropdownMenu>
                      </CustomDropdown>
                    ) : null}

                    <div
                      className={`
                        bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                        hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                        
                        py-[10px] px-[12px] rounded-[5px] text-center 
                        text-[#fff] text-[12px] font-semibold text-nowrap 
                        flex items-center justify-center transition-all
                        gap-1
                        cursor-pointer
                      `}
                      onClick={() => {
                        setShowLead(true);
                      }}
                    >
                      <PlusIcon />
                      Add Lead
                    </div>
                  </div>
                </div>
              </div>

              {apiData.length > 0 && !isLoading && viewType === "list" ? (
                <UpperTabs
                  activeTab={activeTab}
                  setActiveTab={changeFilter}
                  upparTabs={tabs?.length ? tabs : []}
                  totalEmp={apiData?.length}
                  userData={apiData}
                  DepartmentIcons={leadUpperTabIcons}
                  onInnerChange={innerChange}
                  isAllFilterShow={true}
                  upparTabsLimite={4}
                  UpparAllIcon={null}
                />
              ) : null}

              {/* BODY */}
              <div
                className={Style.empDirectory_body}
                style={
                  viewType == "list"
                    ? { height: "calc(100vh - 100px)" }
                    : { height: "calc(100vh - 50px)" }
                }
              >
                {viewType === "list" ? (
                  isLoading ? (
                    <InnerLoader />
                  ) : !apiData?.length ? (
                    <div className="flex justify-center items-center w-full h-full">
                      <DataNotFound title={"Leads"} />
                    </div>
                  ) : (
                    <>
                      <TableCard ref={tableRef}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell header sticky>
                                <div className="flex gap-2 items-center">
                                  <div className={Style.tableCheckBox}>
                                    <label className={Style.custom_checkbox}>
                                      <input
                                        type="checkbox"
                                        checked={
                                          apiData.length > 0 &&
                                          selectedDeals.lead_ids.length +
                                            selectedDeals.user_ids.length ===
                                            apiData.length
                                        }
                                        className={Style.customCheckbox}
                                        onChange={(e) =>
                                          toggleSelectAll(e.target.checked)
                                        }
                                      />
                                      <span className={Style.checkmark}></span>
                                    </label>
                                  </div>
                                  {/* <TableHeaderWrap>
                                    <span className="pl-[50px]">Name</span>
                                  </TableHeaderWrap> */}
                                </div>
                              </TableCell>
                              {tableHeader?.map((eachHead, index) =>
                                eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                  <TableCell header key={index}>
                                    <TableHeaderWrap
                                      iconText={eachHead?.key}
                                      isIcon={true}
                                    >
                                      <span>{eachHead?.value}</span>
                                    </TableHeaderWrap>
                                  </TableCell>
                                ) : null,
                              )}
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {(apiApiFilter ? apiData : filteredData)?.map(
                              (eachList, index) => {
                                return (
                                  <TableRow key={`${index}`}>
                                    <TableCell sticky>
                                      <div
                                        className={`${Style.tableActionArea}`}
                                      >
                                        <div className="flex gap-2 items-center">
                                          <div className={Style.tableCheckBox}>
                                            <label
                                              className={Style.custom_checkbox}
                                            >
                                              <input
                                                type="checkbox"
                                                className={Style.customCheckbox}
                                                checked={
                                                  eachList.leadid
                                                    ? selectedDeals.lead_ids.includes(
                                                        eachList.leadid,
                                                      )
                                                    : selectedDeals.user_ids.includes(
                                                        eachList.userid,
                                                      )
                                                }
                                                onChange={() =>
                                                  toggleSelectRow(
                                                    eachList.leadid ||
                                                      eachList.userid,
                                                    eachList.leadid
                                                      ? "lead"
                                                      : "user",
                                                  )
                                                }
                                              />
                                              <span
                                                className={Style.checkmark}
                                              ></span>
                                            </label>
                                          </div>

                                          {/* <AvatarProfile
                                            src={eachList?.userimg}
                                            title={eachList?.name}
                                            brand={eachList?.source}
                                          /> */}

                                          <TableFirstCol
                                            src={eachList?.userimg}
                                            name={eachList?.name}
                                            emptype={eachList?.status}
                                            id={eachList?.product_name}
                                            data={eachList}
                                            isTypeTagShow={true}
                                          />
                                        </div>

                                        <div
                                          className={
                                            Style.tableActionAreaBtnGrpup
                                          }
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                            onClick={() => {
                                              editLead(eachList);
                                            }}
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{ color: "#FF9500" }}
                                            >
                                              <NewEditIcon className="h-4.5 w-4.5" />
                                            </div>
                                          </div>

                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                            onClick={() => {
                                              setEmpPopup(true);
                                              setEmpData(eachList);
                                            }}
                                          >
                                            <div
                                              className={Style.icon}
                                              style={{ color: "#007AFF" }}
                                            >
                                              <NewEyeIcon className="h-4.5 w-4.5" />
                                            </div>
                                          </div>

                                          {eachList?.leadid ? (
                                            <Link
                                              to={`/leads/leadDetail/${eachList?.leadid}`}
                                              target="_blank"
                                              className={
                                                "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                              }
                                            >
                                              <div
                                                className={Style.icon}
                                                style={{ color: "#34C759" }}
                                              >
                                                <NewCardIcon className="h-4.5 w-4.5" />
                                              </div>
                                            </Link>
                                          ) : eachList?.userid ? (
                                            <Link
                                              // to={`/contacts/contact-details/${eachList?.userid}`}
                                              to={`/lead-account/detail/${eachList?.userid}/contact`}
                                              // to={`/detail-page/detail/${eachList?.userid}/contact`}
                                              target="_blank"
                                              className={
                                                "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                              }
                                            >
                                              <div
                                                className={Style.icon}
                                                style={{ color: "#34C759" }}
                                              >
                                                <NewCardIcon className="h-4.5 w-4.5" />
                                              </div>
                                            </Link>
                                          ) : null}

                                          <Tooltip
                                            content={
                                              eachList?.schedules
                                                ? `Last schedule: ${eachList?.schedules}`
                                                : "No schedule yet"
                                            }
                                            position="top center"
                                            className={Style.btn}
                                          >
                                            <div
                                              className={
                                                "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                              }
                                            >
                                              {eachList?.schedules ? (
                                                <CheckCircle2 className="h-4 w-4 text-emerald-500" />
                                              ) : (
                                                <ShieldX className="h-4 w-4 text-amber-500" />
                                              )}
                                            </div>
                                          </Tooltip>
                                        </div>
                                      </div>
                                    </TableCell>
                                    {tableHeader?.map((eachHead, i) =>
                                      eachHead.is_visible === 1 &&
                                      eachHead?.show == 1 ? (
                                        <>
                                          {eachHead.key === "leadtype" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`text-center capitalize ${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList[eachHead.key] ===
                                              "unpaid" ? (
                                                <StatusChip color="red">
                                                  {eachList[eachHead.key] ||
                                                    "--"}
                                                </StatusChip>
                                              ) : (
                                                <StatusChip color="green">
                                                  {eachList[eachHead.key] ||
                                                    "--"}
                                                </StatusChip>
                                              )}
                                            </TableCell>
                                          ) : eachHead.key == "email" ? (
                                            <TableCell
                                              key={`td-${i}`}
                                              className={`${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList[eachHead?.key] ? (
                                                // <a
                                                //   href={
                                                //     `mailto:${eachList[eachHead?.key]
                                                //     }` || ""
                                                //   }
                                                // >
                                                //   {eachList[eachHead?.key] ||
                                                //     "--"}
                                                // </a>

                                                <TableLink
                                                  href={
                                                    `mailto:${
                                                      eachList[eachHead?.key]
                                                    }` || ""
                                                  }
                                                  text={
                                                    eachList[eachHead?.key] ||
                                                    "--"
                                                  }
                                                />
                                              ) : (
                                                "--"
                                              )}
                                            </TableCell>
                                          ) : eachHead.key == "source" ? (
                                            <TableCell>
                                              <TableDepartmentTag>
                                                {eachList?.source}
                                              </TableDepartmentTag>
                                            </TableCell>
                                          ) : eachHead.key === "status" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`capitalize ${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList.status ? (
                                                <>
                                                  {eachList?.leadid ? (
                                                    <div
                                                      className={`${Style.tableActionArea} flex items-center gap-2`}
                                                    >
                                                      <StatusChip
                                                        color={
                                                          eachList.status ===
                                                          "New Lead"
                                                            ? "blue"
                                                            : eachList.status ===
                                                                "Attempted"
                                                              ? "yellow"
                                                              : eachList.status ===
                                                                  "Voicemail"
                                                                ? "red"
                                                                : "green"
                                                        }
                                                      >
                                                        {eachList[
                                                          eachHead.key
                                                        ] || "--"}
                                                      </StatusChip>
                                                      <div
                                                        className={
                                                          Style.tableActionAreaBtnGrpup
                                                        }
                                                      >
                                                        <div
                                                          className={
                                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                                          }
                                                          onClick={() => {
                                                            editLeadStatus(
                                                              eachList,
                                                            );
                                                          }}
                                                        >
                                                          <div
                                                            className={
                                                              Style.icon
                                                            }
                                                            style={{
                                                              color: "#FF9500",
                                                            }}
                                                          >
                                                            <NewEditIcon className="h-4.5 w-4.5" />
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <StatusChip
                                                      color={
                                                        eachList.status ===
                                                        "Pending"
                                                          ? "blue"
                                                          : "green"
                                                      }
                                                    >
                                                      {eachList[eachHead.key] ||
                                                        "--"}
                                                    </StatusChip>
                                                  )}
                                                </>
                                              ) : (
                                                "-"
                                              )}
                                            </TableCell>
                                          ) : eachHead.key ===
                                            "last_comment" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList?.last_comment
                                                ?.comment ?? "-"}
                                            </TableCell>
                                          ) : eachHead.key === "assigned" ? (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              <div className="flex">
                                                {Array.isArray(
                                                  eachList?.assigned,
                                                ) &&
                                                eachList.assigned.length > 0 ? (
                                                  eachList.assigned.map(
                                                    (user, idx) => (
                                                      <Tooltip
                                                        key={idx}
                                                        content={user.name}
                                                        position="top center"
                                                      >
                                                        <div
                                                          className={`relative ${
                                                            idx !== 0
                                                              ? "-ml-2"
                                                              : ""
                                                          }`} // overlap but prevent transparency blend
                                                          // style={{
                                                          //   zIndex: eachList.assigned.length - idx, // keeps left-to-right stacking clean
                                                          // }}
                                                        >
                                                          {/* {user?.userimg ? (
                                                          <img
                                                            src={user.userimg}
                                                            alt={user.name}
                                                            // className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                                             className="h-8 w-8 flex items-center justify-center rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm"
                                                            onError={(e) => {
                                                              e.target.onerror =
                                                                null;
                                                              e.target.style.display =
                                                                "none";
                                                              const fallback =
                                                                document.createElement(
                                                                  "div"
                                                                );
                                                              fallback.className =
                                                                "h-8 w-8 flex items-center justify-center rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-lg";
                                                              fallback.innerText =
                                                                (
                                                                  (user?.name?.split(
                                                                    " "
                                                                  )[0]?.[0] ||
                                                                    "") +
                                                                  (user?.name?.split(
                                                                    " "
                                                                  )[1]?.[0] ||
                                                                    "")
                                                                ).toUpperCase();
                                                              e.target.parentElement.appendChild(
                                                                fallback
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                                            {(user?.name?.split(
                                                              " "
                                                            )[0]?.[0] || "") +
                                                              (user?.name?.split(
                                                                " "
                                                              )[1]?.[0] || "")}
                                                          </div>
                                                        )} */}
                                                          <Avatar
                                                            src={user?.userimg}
                                                            title={user?.name}
                                                            className="border-2 border-gray-200 shadow-sm "
                                                          />
                                                        </div>
                                                      </Tooltip>
                                                    ),
                                                  )
                                                ) : eachHead.key ===
                                                  "priority" ? (
                                                  <TableCell
                                                    key={`${i}-${index}`}
                                                    className={`text-center capitalize ${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                                  >
                                                    {eachList[eachHead?.key] ==
                                                    "high" ? (
                                                      <StatusChip color="red">
                                                        High
                                                      </StatusChip>
                                                    ) : eachList[
                                                        eachHead?.key
                                                      ] == "low" ? (
                                                      <StatusChip color="green">
                                                        Low
                                                      </StatusChip>
                                                    ) : eachList[
                                                        eachHead.key
                                                      ] == "medium" ? (
                                                      <StatusChip color="yellow">
                                                        Medium
                                                      </StatusChip>
                                                    ) : (
                                                      "-"
                                                    )}
                                                  </TableCell>
                                                ) : (
                                                  <span className="text-gray-400 text-sm">
                                                    -
                                                  </span>
                                                )}
                                              </div>
                                            </TableCell>
                                          ) : (
                                            <TableCell
                                              key={`${i}-${index}`}
                                              className={`${eachHead?.dim_text == 1 ? "!text-[#9ca3af]" : ""}`}
                                            >
                                              {eachList[eachHead.key] ?? "-"}
                                            </TableCell>
                                          )}
                                        </>
                                      ) : null,
                                    )}
                                  </TableRow>
                                );
                              },
                            )}
                          </TableBody>
                        </Table>
                      </TableCard>
                    </>
                  )
                ) : (
                  <LeadBoard
                    filters={boardFilters}
                    groupBy={groupBy}
                    sendFilters={getBoardFilter}
                    ClientList={Clients}
                    UserList={usersList}
                    onLoadMoreClients={() => loadClients(page + 1)}
                    hasMoreClients={hasMoreClients}
                    isLoadingClients={isLoadingClients}
                    ProductList={products}
                    PackageList={PackageList}
                    DealStages={DealStages}
                    country={country}
                    SubProductList={subProducts}
                    BrandList={brands}
                    fetchSubProducts={getSubProducts}
                    fetchPackages={getPackages}
                    onError={onError}
                    onSubmit={onSuccess}
                  />
                )}
              </div>

              {viewType == "list" ? (
                <>
                  {" "}
                  {!isLoading ? (
                    apiData?.length > 0 ? (
                      <div
                        className={`-mt-[12px] ${Style.table_footer}`}
                        style={{ alignItems: "center" }}
                      >
                        <div className={Style.table_footer_left}>
                          {`showing 1 to ${apiData?.length} of ${
                            tablePagination?.total || apiData?.length
                          }`}
                        </div>

                        {tablePagination ? (
                          <div className={Style.empDirectory_footer}>
                            {tablePagination?.next_page_url ? (
                              <button
                                className={`bg-[linear-gradient(92deg,#0057FB_1.54%,#003495_114.12%)] 
                                              hover:bg-[linear-gradient(92deg,#0066FF_1.54%,#0045AA_114.12%)]
                                              
                                              py-[10px] px-[17px] rounded-[5px] text-center 
                                              text-[#fff] text-[12px] font-semibold text-nowrap 
                                              flex items-center justify-center transition-all
                                              gap-1
                                              cursor-pointer min-w-[96px]`}
                                onClick={() => {
                                  if (btnLoader) return;
                                  // setPageCount(pageCount + 1);
                                  setBtnLoader(true);
                                  // filterData({ page: pageCount + 1, btnCall: true });
                                  getData({
                                    page: tablePagination?.next_page_url,
                                  });
                                }}
                              >
                                {btnLoader ? (
                                  <InnerLoader
                                    className={`${Style.loader} !w-3 !h-3 !border-2`}
                                    textStatus={false}
                                  />
                                ) : (
                                  "Load More"
                                )}
                              </button>
                            ) : null}
                          </div>
                        ) : null}

                        <div
                          className={`${Style.table_footer_left} ${Style.rightText}`}
                        ></div>
                      </div>
                    ) : null
                  ) : (
                    <div
                      className={Style.table_footer}
                      style={{ alignItems: "center" }}
                    >
                      <div className={Style.table_footer_left}>
                        <Skeleton width={"50%"} height={15} />
                      </div>

                      <div className={Style.empDirectory_footer}>
                        <Skeleton width={"180px"} height={40} />
                      </div>

                      <div
                        className={`${Style.table_footer_left} ${Style.rightText}`}
                      ></div>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters, filterName, editingFilter) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="get-leads"
        />
      )}

      {showBoardFilterModal && (
        <DynamicFilter
          data={getBoardFilterData()}
          onClose={() => setShowBoardFilterModal(false)}
          returnData={boardFilters}
          onSave={(filters) => {
            setBoardFilters(filters);
            setShowBoardFilterModal(false);
          }}
          saveFilter={boardSaveFilters}
          apiUrl={`leads-kanban?group_by=${groupBy}`}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="get-leads"
        />
      )}

      {empPopup && empData?.leadid && (
        <LeadQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          data={empData}
          ProductList={products}
          PackageList={PackageList}
          DealStages={DealStages}
          onError={onError}
          onSuccess={onSuccess}
          onStatusUpdate={onStatusUpdate}
        />
      )}

      {empPopup && empData?.userid && (
        <ContactQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          ClientList={Clients}
          UserList={usersList}
          onLoadMoreClients={() => loadClients(page + 1)}
          hasMoreClients={hasMoreClients}
          isLoadingClients={isLoadingClients}
          data={empData}
          ProductList={products}
          PackageList={PackageList}
          DealStages={DealStages}
          onAlert={(type, message) =>
            setAlertData({ isShow: true, type, message })
          }
          onError={onError}
          onSuccess={onSuccess}
        />
      )}

      {showLead && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setShowLead(false);
            setCurrentData({});
          }}
          data={currentData}
          statusList={statusList}
          tabIndex={0}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {showStatus && (
        <UpdateLeadStatus
          onClose={() => {
            setShowStatus(false);
            setCurrentStatus({});
          }}
          statusdata={currentStatus}
          statusList={statusList}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {showBulkConvertModal && (
        <ConvertLeadToDeal
          leadData={null}
          bulkData={selectedDeals}
          onClose={() => {
            setShowBulkConvertModal(false);
            setBulkDataChange(false);
            setBulkDatavalue("");
          }}
          // PackageList={PackageList}
          DealStages={DealStages}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {bulkDataChange && (
        <BulkEdit
          onClose={() => {
            setBulkDataChange(false);
            setBulkDatavalue("");
          }}
          users={selectedDeals}
          // PackageList={PackageList}
          BrandList={brands}
          DealStages={DealStages}
          Countries={country}
          UsersList={usersList}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>

      {/* <AddSales/> */}
    </>
  );
};

export default Lead;
